module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[62]427.9020e63.woff2";